import { createRequire } from 'node:module'

const requireFromCli = createRequire(import.meta.url)

export function canResolveFromProject(cwd: string, name: string): boolean {
  try {
    requireFromCli.resolve(name, { paths: [cwd] })
    return true
  } catch {
    return false
  }
}
